import { gql } from '@apollo/client';
export const FINANCER_QUERY = (is_manage_financier_listing= false, product_type = []) => gql`
query {
    financier_list(api_called_by:"WEB", is_manage_financier_listing:${is_manage_financier_listing}, business_id: [${product_type}]) {
      id
      logo
      status
      product_type
      financial_code
      financierlang {
        lang_id
        financier_name
        financier_id
      }
    }
  }
`;

export const CREATE_FINANCIER_MUTATION = ()=> {
  
  
  return `mutation createFinancier($financierInput: FinancierInput!) {
    create_financier(financierInput: $financierInput) {
      id
    }
  }
  `
}

export const UPDATE_FINANCIER = gql`
  mutation update_financier_business_mapping($financierBusinessInput: FinancierBusinessInput!) {
    update_financier_business_mapping(financierBusinessInput: $financierBusinessInput) {
      message
    }
  }
`;


export const MARKET_INCENTIVE=(financier_id =[])=> gql`
  query {
  market_incentives(financier_id: ${financier_id}) {
    financier_id
    wht_percentage_on_marketplace_incentive
    marketplace_incentive_percentage_gross
    mi_effective_date
  }
}
`;

export const SAVE_MARKET_INCENTIVE = gql`
  mutation SaveMarketIncentives($MarketIncentiveInput: SaveMarketIncentiveInput!) {
    save_market_incentives(MarketIncentiveInput: $MarketIncentiveInput) {
      financier_id
      message
      marketplace_incentive_percentage_gross
      wht_percentage_on_marketplace_incentive
    }
  }
`;

